module.exports = __webpack_public_path__ + "static/media/Night-rainy.1355eea8.svg";